// extracted by mini-css-extract-plugin
export var cardLayout = "_23-1";
export var paginationContainer = "_23-0";